import { SupplierGroupMessage } from '../../../../types/SupplierGroupMessage';
import { GetSupplierGroupsParams } from '../../../common/api/clients/supplierGroups.api';
import { queries } from '../../../common/api/queryKeys/queries';
import { usePaginationQuery } from '../../../common/hooks/usePaginationQuery';

export const useSupplierGroupsPagination = (params: GetSupplierGroupsParams) => {
    const nextPage = queries.supplierGroups.pagination({ ...params, page: params.page + 1 });

    return usePaginationQuery<SupplierGroupMessage>({
        ...queries.supplierGroups.pagination(params),
        prefetchQueryKey: nextPage.queryKey,
        prefetchQueryFn: nextPage.queryFn,
    });
};
